var map = {
	"./discolp.md": 1829,
	"./discolp_complete.md": 1830,
	"./fakerdao.md": 1831,
	"./fakerdao_complete.md": 1832,
	"./instances.md": 1833,
	"./instances_complete.md": 1834,
	"./mainchef.md": 1835,
	"./mainchef_complete.md": 1836,
	"./maytheforcebewithyou.md": 1837,
	"./maytheforcebewithyou_complete.md": 1838,
	"./p2pswapper.md": 1839,
	"./p2pswapper_complete.md": 1840
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 662;


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels ^\.\/.*$
// module id = 662
// module chunks = 0